import hzApp from "hzApp";
var appChannels = {
	"002": "APPS",
	"004": "A360",
	"007": "BAID",
	"009": "TENC",
	"011": "ANZI",
	"013": "LENO",
	"018": "MEIZ",
	"019": "SANX",
	"025": "PPZS",
	"027": "MAYI",
	"030": "CHUI",
	"050": "PC01",
	"051": "PC02",
	"052": "PC03",
	"053": "PC04",
	"054": "PC05",
	"055": "PC06",
	"056": "H501",
	"065": "H502",
	"014": "HWEI",
	"010": "XIMI",
	"020": "OPPO",
	"031": "VIVO",
	default: "ANDD",
};

export default {
	/**
	 * 倒计时方法
	 * @param start
	 * @param end
	 * @param processingCb
	 * @param endCb
	 */
	endTime: function (start, end, processingCb, endCb) {
		var left = ((end - start) / 1000) | 0;
		var hours = 0,
			minutes = 0;
		// seconds = 0;
		var leftTimer = setInterval(function () {
			while (left > -1) {
				hours = Math.floor(left / 3600);
				minutes = Math.floor((left - hours * 3600) / 60);
				// seconds = left - hours * 3600 - minutes * 60;
				processingCb(
					hours < 10 ? "0" + hours : hours,
					minutes < 10 ? "0" + minutes : minutes,
					left
				);
				left--;
				return;
			}
			clearTimeout(leftTimer);
			leftTimer = null;
			endCb();
		}, 1000);
	},

	/**
	 * 从Url获取名为`key`的查询参数值，如果不存在，返回undefined
	 * 注：不支持数组格式的参数名获取
	 * @param key
	 * @param [url] String
	 *
	 * @example
	 * getQuery(p1)
	 * getQuery(p1, "?p1=3")    // "3"
	 */
	getQuery: function (key, url) {
		var pos;
		url = url || window.location.href;
		pos = url.indexOf("?") + 1;

		if (pos === 0) {
			return;
		}

		url = "&" + url.substr(pos).split("#")[0];

		var reg = new RegExp("&" + key + "(?:=([^&]*)|&|$)", "i");
		var match = url.match(reg);
		if (match) {
			try {
				return decodeURIComponent(match[1] || "");
			} catch (e) {
				return match[1];
			}
		}
		return;
	},

	/**
	 * 获取Url所有参数，作为对象返回
	 * @example
	 * getQueryObj()                // collect all parameter-value pairs of current page URL
	 * getQueryObj('=a')            // {'': 'a'}
	 * getQueryObj("?p1=A&p2=B")    // {p1: "A", p2: "B"}
	 * getQueryObj('http://domain.com/?p1=a=b&b&&=b&&p2=c%26#d=e&f=g')
	 */
	getQueryObj: function (url) {
		var result;
		var queryObj = {};
		var reg = /&([^=&]*)=?([^&]*)/g;
		var str = url === undefined ? window.location.search : String(url);

		if (str.indexOf("?") === -1) {
			return queryObj;
		}

		str = "&" + str.substr(str.indexOf("?") + 1).split("#")[0];

		while ((result = reg.exec(str)) !== null) {
			if (result[0] != "&") {
				queryObj[result[1]] = decodeURIComponent(result[2]);
			}
		}
		return queryObj;
	},
	// 获取iframe的url
	getParentUrl: function () {
		let url = null;
		if (window.parent !== window) {
			try {
				url = window.parent.location.href;
			} catch (e) {
				url = document.referrer;
			}
		}
		return url;
	},
	/**
	 * 根据客户端类型获取配置
	 * @param client
	 */
	getConfigByClient: function (client) {
		let config = global.config || {};
		let result = config[client === 1 ? "www" : "touch"] || {};
		result.clientType = hzApp.isApp
			? hzApp.getClientSource()
			: result.clientType;
		return result;
	},
	/**
	 * 根据邮箱获取对应邮箱地址
	 * @param email
	 * @return {string}
	 */
	getUrlByEmail: function (email) {
		var hash = {
			"qq.com": "http://mail.qq.com",
			"gmail.com": "http://mail.google.com",
			"126.com": "http://mail.126.com",
			"sohu.com": "http://mail.sohu.com/",
			"tom.com": "http://mail.tom.com/",
			"139.com": "http://mail.10086.cn/",
			"sina.com": "http://mail.sina.com.cn",
			"163.com": "http://mail.163.com",
			"hotmail.com": "http://www.hotmail.com",
			"huize.com": "https://exmail.qq.com/login",
		};
		var domain = email.split("@")[1];
		var url = "";
		for (var j in hash) {
			console.log(j);
			url = hash[domain];
		}
		return url;
	},
	makeFullUrl: function (url) {
		url = url || window.location.href;
		if (!/^http(s|)/.test(url) && !/^\/\//.test(url)) {
			return "https://" + url;
		}
		return url;
	},
	getAppChannel: function () {
		if (!hzApp.isApp) {
			return "";
		}
		var isiOSApp = hzApp.isIOSApp;
		if (isiOSApp) {
			return "APPS";
		}
		if (window.basics && typeof window.basics.getChannel === "function") {
			var channels = window.basics.getChannel() || "";
			var key = channels.split("_")[1];
			if (appChannels[key]) {
				return appChannels[key];
			}
		}
		return appChannels["default"];
	},
	/**
	 * 处理弹出层滑动穿透问题
	 */
	ModalHelper: (function (bodyCls) {
		var scrollTop;
		return {
			afterOpen: function () {
				scrollTop =
					document.body.scrollTop || document.documentElement.scrollTop;
				document.body.classList.add(bodyCls);
				document.body.style.top = -scrollTop + "px";
			},
			beforeClose: function () {
				document.body.classList.remove(bodyCls);
				// scrollTop lost after set position:fixed, restore it back.
				window.scrollTo(0, scrollTop);
			},
		};
	})("modal-open"),
};



// WEBPACK FOOTER //
// ./src/utils/helper.js